import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-dhwani-material-temp-form',
  template: `
    <p>
      dhwani-material-temp-form works!
    </p>
  `,
  styles: [
  ]
})
export class DhwaniMaterialTempFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
